export const emailValidation = (email: string) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const passwordValidation = (password: string) => {
  if (!password) return false;
  if (/^(?=.*[A-Z])(?=.*\d).+$/.test(password) && password.length >= 8) {
    return true;
  }
  return false;
};

export const getRefreshToken = () => {
  return localStorage.getItem("refresh_token");
};

export const getAccessToken = () => {
  return localStorage.getItem("access_token");
};
